import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabNine = ({
  setOthers,
  others,
  onClickAll
}) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="others-form-all"
          control={
            <Checkbox
              id="others-all"
              checked={others.every((dash) => dash.value)}
              onClick={(e) => onClickAll(others, 'common', setOthers, e)}
            />
          }
          label="All"
        />
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Resources' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Projects' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'View Dashboard' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;

                      //remove download when value false
                      if(!e.target.checked){
                        let i = others.map(e => e.name).indexOf('Download Utilization Report');
                        let item2 = {
                          id: others[i].id,
                          name: others[i].name,
                          tab: others[i].tab,
                          value: false
                        };
                        items[i] = item2;
                      }
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
      <Grid item xs={4}>
        {others.map(
          (data, index) =>
            data.name === 'Download Utilization Report' && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={others[index]?.value}
                    onChange={(e) => {
                      let items = [...others];
                      let item = { ...items[index] };

                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;

                      //add dashboard
                      if(e.target.checked){
                        let i = others.map(e => e.name).indexOf('View Dashboard');
                        let item2 = {
                          id: others[i].id,
                          name: others[i].name,
                          tab: others[i].tab,
                          value: true
                        };
                        items[i] = item2;
                      } else{
                        let i = others.map(e => e.name).indexOf('View Dashboard');
                        let item2 = {
                          id: others[i].id,
                          name: others[i].name,
                          tab: others[i].tab,
                          value: false
                        };
                        items[i] = item2;
                      }
                      setOthers(items);
                    }}
                  />
                }
                label={data.name}
              />
            )
        )}
      </Grid>
    </Grid>
  );
};

export default TabNine;
